// Mock data for development

export const mockProfile = {
  name: 'xeerp',
  title: 'Roblox Front-End Developer',
  //bio:  'Passionate Roblox developer specializing in creating immersive gameplay experiences. I focus on building engaging mechanics, optimizing performance, and bringing creative ideas to life on the Roblox platform.',
  skills: ['Front-End', 'UI/UX']
};

export const mockWorks = [ // current works
  {
    id: 1,
    title: 'Battlegrounds Skills',
    status: 'discontinued', // wip, discontinued, on
    description: 'Skills from a battleground developed by friends.',
    tech: ['Front-End'],
    videourl: 'https://www.youtube.com/watch?v=ttgx7_b3Bew',
    year: '2025'
  },
  {
    id: 2,
    title: 'Parry Based Combat',
    status: 'discontinued', // wip, discontinued, on
    description: 'Combat system developed for testing purposes only.',
    tech: ['Front-End', 'Back-End', 'VFXs'],
    videourl: 'https://www.youtube.com/watch?v=KOFElp--GMo',
    year: '2025'
  },
];

export const mockRobloxGames = [ // roblox games
  '17083240635', // slayer online
];

export const mockContacts = [ // contacts
  {
    platform: 'Discord',
    handle: '@xeerp',
    icon: 'MessageSquare'
  },
  {
    platform: 'Twitter',
    handle: '@xeerps',
    url: 'https://twitter.com/xeerps',
    icon: 'Twitter'
  },
  {
    platform: 'GitHub',
    handle: 'xerpxz',
    url: 'https://github.com/xerpxz',
    icon: 'Github'
  }
];